import { render, staticRenderFns } from "./admin-expenses.vue?vue&type=template&id=584fb2df"
import script from "./admin-expenses.vue?vue&type=script&lang=js"
export * from "./admin-expenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports